<div class="minute-stepper">
  <button type="button" class="btn-decrement" (click)="decrement()" aria-label="Decrease">−</button>
  <div class="value-display">
    <input type="number"
      [ngModel]="valueMinutes"
      (ngModelChange)="setMinutes($event)"
      [min]="min"
      [max]="max"
      aria-label="Minutes">
    <span class="suffix">min</span>
  </div>
  <button type="button" class="btn-increment" (click)="increment()" aria-label="Increase">+</button>
</div>
